module.exports = RedNaoFormBuilder('FormBuilder/Utilities/Managers/PriceManager/PriceManager');